/**
 * Converts a numeric index value into its alphabetical counterpart.
 *
 * @param num - The numeric index value.
 * @returns A letter.
 */

export const indexToAlpha = (num = 0): string => {
  // ASCII value of first character
  const A = 'A'.charCodeAt(0)

  return String.fromCharCode(A + num)
}
